<template>
  <section class="is-fullheight" id="contact-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <div class="container has-text-centered">
        <h1 class="title is-spaced">
          <go-to-dashboard />
          Mande um oi para nós
          <b-icon icon="comments" style="margin-left: 0.5rem"></b-icon>
        </h1>

        <h2 class="subtitle is-spaced">
          Dúvidas, críticas, sugestões.. fique à vontade :)
        </h2>

        <div class="message-div">
          <b-field v-if="!isDisabled">
            <b-input
              v-model="message"
              maxlength="2000"
              type="textarea"
              rows="8"
              :disabled="isDisabled"
            ></b-input>
          </b-field>

          <div class="has-text-left" v-if="!isDisabled">
            <button
              class="button is-primary"
              @click="sendMessage"
              :disabled="isDisabled"
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import goToDashboard from "../common/GoToDashboardButton";

export default {
  mixins: [common],

  components: {
    goToDashboard
  },

  data() {
    return {
      isLoading: false,
      isDisabled: false,
      message: ""
    };
  },

  methods: {
    sendMessage() {
      this.isLoading = true;
      this.$store
        .dispatch("sendMessage", {
          message: this.message
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.dialog.alert({
              title: "Mensagem enviada!",
              message:
                "Obrigado pela mensagem, responderemos no seu e-mail cadastrado o mais breve possível ;)",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa"
            });
            this.isDisabled = true;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
@media (min-width: 700px) {
  .message-div {
    max-width: 70%;
    margin: auto;
  }
}
#contact-panel {
  min-height: 100vh;
  padding: 1.5rem;
  background-color: #f8f7fa;
}
</style>
